import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { auth } from "../../utils/auth";
import { getLink } from "../../utils/helpers";

const Sidebar = ({ toggleModal }) => {
    const location = useLocation();
    const isGastos = location.pathname.indexOf("gastos") > -1;

    return (
        <aside
            className='menu-sidebar d-none d-lg-block'
            onClick={() => toggleModal("showReportes", false)}>
            <div className='logo'>
                <img src='/images/icon/logo-recolector.png' alt='Logo' />
            </div>
            <div className='menu-sidebar__content js-scrollbar1'>
                <nav className='navbar-sidebar'>
                    <ul className='list-unstyled navbar__list'>
                        {auth.can("ver-dashboard") && (
                            <li>
                                <NavLink
                                    className='js-arrow'
                                    to={getLink("/")}
                                    exact>
                                    <i className='fas fa-tachometer-alt' />
                                    Inicio
                                </NavLink>
                            </li>
                        )}
                        {auth.can("ver-dashboard") && (
                            <li className='separator' />
                        )}
                        {auth.can("ver-programacion") && (
                            <li>
                                <NavLink
                                    className='js-arrow'
                                    to={getLink("/programaciones")}>
                                    <i className='fas fa-calendar-alt' />
                                    Programación
                                </NavLink>
                            </li>
                        )}
                        {auth.can("ver-empleados") && (
                            <li className='separator' />
                        )}
                        {auth.can("ver-empleados") && (
                            <li>
                                <NavLink to={getLink("/empleados")}>
                                    <i className='fas fa-users' />
                                    Empleados
                                </NavLink>
                            </li>
                        )}
                        {auth.can("ver-nomina") && (
                            <li>
                                <NavLink to={getLink("/nomina")}>
                                    <i className='fa fa-paste' />
                                    Nómina
                                </NavLink>
                            </li>
                        )}
                        {auth.can("ver-solicitudes") && (
                            <li>
                                <NavLink to={getLink("/solicitudes")}>
                                    <i className='fa fa-clipboard' />
                                    Solicitudes
                                </NavLink>
                            </li>
                        )}
                        {auth.can("ver-reclamaciones") && (
                            <li>
                                <NavLink to={getLink("/reclamaciones")}>
                                    <i className='fa fa-exclamation-circle' />
                                    Reclamaciones
                                </NavLink>
                            </li>
                        )}
                        {auth.can("ver-descuentos") && (
                            <li>
                                <NavLink to={getLink("/descuentos")}>
                                    <i className='fa fa-calculator' />
                                    Descuentos
                                </NavLink>
                            </li>
                        )}
                        {auth.can("ver-vehiculos") && (
                            <li className='separator' />
                        )}
                        {auth.can("ver-vehiculos") && (
                            <li>
                                <NavLink to={getLink("/vehiculos")}>
                                    <i className='fas fa-truck' />
                                    Vehículos
                                </NavLink>
                            </li>
                        )}
                        {auth.can("ver-servicios") && (
                            <li>
                                <NavLink to={getLink("/servicios")}>
                                    <i className='fas fa-wrench' />
                                    Servicios
                                </NavLink>
                            </li>
                        )}
                        {auth.can("ver-rutas") && (
                            <li>
                                <NavLink to={getLink("/rutas")}>
                                    <i className='fas fa-map-marker-alt' />
                                    Rutas
                                </NavLink>
                            </li>
                        )}
                        {auth.can("ver-inventario") && (
                            <li className='separator' />
                        )}
                        {auth.can("ver-inventario") && (
                            <li>
                                <NavLink to={getLink("/inventario")}>
                                    <i className='fas fa-box' />
                                    Inventario
                                </NavLink>
                            </li>
                        )}
                        {auth.can("ver-compras") && (
                            <li>
                                <NavLink to={getLink("/compras")}>
                                    <i className='fas fa-shopping-cart' />
                                    Compras
                                </NavLink>
                            </li>
                        )}
                        {auth.can("ver-gastos") && (
                            <li
                                className={
                                    "has-sub " + (isGastos ? "active" : "")
                                }>
                                <a
                                    href='#sub'
                                    className='parent-label'
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.target.parentElement.classList.toggle(
                                            "active"
                                        );
                                    }}>
                                    <i className='fas fa-money-check-alt' />
                                    Gastos
                                </a>
                                <ul className='sub-menu'>
                                    <li>
                                        <NavLink
                                            to={getLink("/gastos-generales")}>
                                            Generales
                                        </NavLink>
                                    </li>
                                    {auth.can("ver-gastos-generales") && (
                                        <li>
                                            <NavLink to={getLink("/gastos")}>
                                                Vehículos
                                            </NavLink>
                                        </li>
                                    )}
                                </ul>
                            </li>
                        )}
                        {auth.can("ver-dashboard") && (
                            <li className='separator' />
                        )}
                        {auth.can("ver-contactos") && (
                            <li>
                                <NavLink to={getLink("/contactos")}>
                                    <i className='fas fa-address-book' />
                                    Contactos
                                </NavLink>
                            </li>
                        )}
                    </ul>
                </nav>
            </div>
        </aside>
    );
};

export default Sidebar;
